'use client';
import { RefObject, useEffect, useState } from 'react';

const CustomScrollBar = ({
  scrollRef,
  className = '',
}: {
  scrollRef: RefObject<HTMLDivElement>;
  className?: string;
}) => {
  const [scrollLeft, setScrollLeft] = useState(0); // 存储滚动容器的水平滚动距离

  // 监听滚动事件，实时更新 scrollLeft
  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        setScrollLeft(scrollRef.current.scrollLeft);
      }
    };

    if (scrollRef.current) {
      scrollRef.current.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);
    }

    return () => {
      if (scrollRef.current) {
        scrollRef.current.removeEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
      }
    };
  }, [scrollRef]);

  const getIndicatorLeft = () => {
    if (!scrollRef.current) return 0;
    const { scrollWidth, clientWidth } = scrollRef.current;
    const scrollableWidth = scrollWidth - clientWidth; // 可滚动的总宽度（内容宽度 - 容器可见宽度）
    if (scrollableWidth === 0) return -1; // 无滚动时，不展示
    const ratio = scrollLeft / scrollableWidth; // 滚动比例（0~1）
    const parentWidth = 24; // 白色条父容器的宽度
    const indicatorWidth = 8; // 白色条自身宽度
    const maxLeft = parentWidth - indicatorWidth; // 白色条可移动的最大范围
    return maxLeft * ratio; // 最终 left 偏移量
  };
  const indicatorLeft = getIndicatorLeft();
  return (
    <div className={`${className}`}>
      {indicatorLeft !== -1 && (
        <div className="relative bg-[#121C5933] h-[2px] w-[24px] mt-[24px] mx-auto hidden mobile:block overflow-hidden">
          <div
            className="absolute left-0 top-0 bg-[#2D2D2E] h-full w-[8px]"
            style={{
              left: `${indicatorLeft}px`,
            }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default CustomScrollBar;
